// extracted by mini-css-extract-plugin
module.exports = {"LogoImg":"UserInfo_LogoImg__3rhxO","Header_img":"UserInfo_Header_img__30Wub"};